<div class="row">
  <div class="col-12">
    <div class="marquee">
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 p-0 h-100">
    <div id="carouselIndicators" class="carousel slide carousel-fade h-100" data-ride="carousel">

      <ol class="carousel-indicators">
        <li *ngFor="let n of carouselList; let i = index" data-target="#carouselIndicators" [attr.data-slide-to]="i"
          [class]="i == 0 ? 'active' : ''">
        </li>
      </ol>

      <div class="carousel-inner">
        <div *ngFor="let n of carouselList; let i = index" [class]="(i ==0) ? 'carousel-item active' : 'carousel-item'">
          <img src="../../assets/images/{{n.img}}" class="d-block w-100 h-100">
          <div class="carousel-caption d-sm-block"><!--d-none d-md-block-->
            <div class="caption-containner" [style]="sanitize(n.style)">
              <div class="col-12">
                <label class="{{'carousel-caption-lbl carousel-caption-lbl' + i}}" [style]="sanitize(n.caption1.style)">
                  {{n.caption1.text}}
                </label>
              </div>
              <div class="col-12">
                <label class="{{'carousel-caption-lbl carousel-caption-lbl' + i}}" [style]="sanitize(n.caption2.style)">
                  {{n.caption2.text}}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a class="carousel-control-prev" href="#carouselIndicators" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselIndicators" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>

<div class="row ">
  <div class="col-12 p-4" style="padding-bottom: 0px !important;">

    <div class="row mt-3 not-crisis">
      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container simulateMenu"  style="display: none;" (click)="goToSimulate()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/คำนวณเงินคุ้มครอง.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{simulateMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{simulateMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 col-sm-6 p-2 news-menu" style="display: none;"  (click)="goToNews()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ข่าว.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">News</label>
            <label *ngIf="lang == 'th'">ข่าวสาร</label>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container contactDpaMenu"  style="display: none;" (click)="goToContactDpa()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ติดต่อ DPA.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{contactDpaMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{contactDpaMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container faqMenu"  style="display: none;" (click)="goToFaq()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ติดต่อสอบถาม.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{faqMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{faqMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3  justify-content-center crisis">
      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container trackStatusMenu"  style="display: none;" (click)="goToStatusTracking()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ติดตามสถานะ.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{trackStatusMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{trackStatusMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container inquiryMenu"  style="display: none;" (click)="goToRefundDeposits()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/สอบถามเงินคุ้มครอง.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{inquiryMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{inquiryMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>
      <!--<div class="col-12 col-sm-6 col-md-3 p-2 menu-container news-menu" style="display: none;"  (click)="goToNews()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ข่าว.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">News</label>
            <label *ngIf="lang == 'th'">ข่าวสาร</label>
          </div>
        </div>
      </div>-->

      <div class="w-100"></div>

      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container contactDpaMenu"  style="display: none;" (click)="goToContactDpa()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ติดต่อ DPA.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{contactDpaMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{contactDpaMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 p-2 menu-container faqMenu"  style="display: none;" (click)="goToFaq()">
        <div class="row text-center border rounded w-100 h-100 justify-content-center shadow-box p-4">
          <div class="col-5 col-sm-12" style="height: 70% !important;">
            <img src="../../assets/images/ติดต่อสอบถาม.png" style="height: 100% !important;">
          </div>
          <div class="col-7 col-sm-12 lbl-menu" style="height: 30% !important;">
            <label *ngIf="lang == 'en'">{{faqMenu.dpa_name}}</label>
            <label *ngIf="lang == 'th'">{{faqMenu.dpa_menu_th}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isCrisis"  class="float-right">
  <img src="../../assets/images/DPA_Act000.png" alt="robot" class="robot-img">
</div>


<div *ngIf="isCrisis" class="float-right" style="margin-top: -10vw;">
  <img src="../../assets/images/DPA_Act006.png" alt="robot" class="robot-img">
</div>


// WEBPACK FOOTER //
// ./src/app/index/index.component.html